// NgRx - Store
import { Action, createReducer, on } from '@ngrx/store';
// NgRx - Actions
import * as ShipAccidentsActions from '@accidents/store/actions/ship-accidents.actions';
// Interfaces
import {
  IShipAccidentsRequest,
  IShipAccidentsResponse,
  ISortingAndFilteringCriteria,
} from '@accidents/shared/interfaces/ship-accidents';

export interface IShipAccidentsState {
  data: IShipAccidentsResponse;
  loading: boolean;
  loaded: boolean;
  savedShipAccidentsRequest: IShipAccidentsRequest;
  sortingAndFilteringCriteria: ISortingAndFilteringCriteria;
}

export const shipAccidentsState: IShipAccidentsState = {
  data: null,
  loading: false,
  loaded: false,
  savedShipAccidentsRequest: null,
  sortingAndFilteringCriteria: null,
};

const ShipAccidentsReducer = createReducer(
  shipAccidentsState,
  on(ShipAccidentsActions.reset, state => ({
    ...state,
    data: null,
    loading: false,
    loaded: false,
    savedShipAccidentsRequest: null,
    sortingAndFilteringCriteria: state.sortingAndFilteringCriteria,
  })),
  on(ShipAccidentsActions.shipAccidentsRequested, (state, action) => ({
    ...state,
    loading: true,
    savedShipAccidentsRequest: action.payload,
  })),
  on(ShipAccidentsActions.shipAccidentsResponse, (state, action) => ({
    ...state,
    loading: false,
    loaded: true,
    data: action.payload,
  })),
  on(
    ShipAccidentsActions.saveNewSortingAndFilteringCriteria,
    (state, action) => ({
      ...state,
      sortingAndFilteringCriteria: action.payload,
    })
  )
);

export function reducer(
  state: IShipAccidentsState | undefined,
  action: Action
): IShipAccidentsState {
  return ShipAccidentsReducer(state, action);
}
